// src/services/categoryService.jsx
import http from "./http";

/* --------------------------------
   ADD CATEGORY
   POST /api/categories?action=add
-------------------------------- */
export const addCategory = async (payload) => {
  const res = await http.post("categories?action=add", {
    name: payload.name,
    description: payload.description,
  });

  return res.data;
};

/* --------------------------------
   UPDATE CATEGORY
   POST /api/categories?action=update
-------------------------------- */
export const updateCategory = async (id, payload) => {
  const res = await http.post("categories?action=update", {
    id: id,
    name: payload.name,
    description: payload.description,
  });

  return res.data;
};

/* --------------------------------
   GET ALL CATEGORIES
   POST /api/categories?action=get
-------------------------------- */
export const getCategories = async () => {
  const res = await http.post("categories?action=get");

  return res.data;
};

/* --------------------------------
   GET SINGLE CATEGORY
   POST /api/categories?action=get&id=3
-------------------------------- */
export const getCategoryById = async (id) => {
  const res = await http.post(`categories?action=get&id=${id}`);

  return res.data;
};

/* --------------------------------
   DELETE CATEGORY
   POST /api/categories?action=delete
-------------------------------- */
export const deleteCategory = async (id) => {
  const res = await http.post("categories?action=delete", {
    id: id,
  });

  return res.data;
};